import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Collapse } from 'antd';
import RightMenuDesign from '../../house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../icon/icon';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import SelectionSupplier from '../../../pages/DesignerPage/components/SelectionSuplier/SelectionSuplier';
import CardMaterial from '../../../pages/DesignerPage/components/CardMaterial/CardMaterial';
import { DesignerPageContext } from '../../../pages/DesignerPage/DesignerPage';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGroupMaterial,
  fetchMaterialsByGroup,
} from '../../../store/actions/material.action';
import { ModuleType } from '../../../constants/enum';
import { Spin } from 'antd';
import { Empty } from 'antd';
import { fetchSuppliers } from '../../../store/actions/supplier.action';
import RightSupplierMenu from '../../../pages/DesignerPage/components/RightSupplierMenu/RightSupplierMenu';
import { openMessageError } from '../../common/Message/openMessageError';
import { useTranslation } from 'react-i18next';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { setCurrentSupplier } from '../../../store/reducers/supplier.reducer';
import ButtonTertiarySmall from '../../common/ButtonTertiary/ButtonTertiarySmall';

const RightBacksplashCustomDesign = ({
  open,
  onClose,
  title,
  // materialType = "stone",
}) => {
  const moduleType = ModuleType.BACKSPLASH;
  const { currentMaterial } = useContext(DesignerPageContext);
  const [openSupplier, setOpenSupplier] = useState(false);

  const {
    currentSupplier: { [moduleType]: supplierId },
  } = useSelector(state => state.supplier);
  const timerRef = useRef();

  useEffect(() => {
    if (!supplierId?.id && open) {
      timerRef.current = setTimeout(() => {
        setOpenSupplier(true);
      }, 1000);
    } else {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [open, supplierId, currentMaterial]);

  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{ root: 'top-84', content: 'flex flex-col !p-0 gap-0' }}
        header={
          <div className="flex self-stretch items-center justify-between gap-8 grow">
            <span className="text-title-large">{title}</span>
            <ButtonIconGhostMedium icon={<Icon.ICClose />} onClick={onClose} />
          </div>
        }
        content={
          open ? (
            <RenderContent
              openSupplier={openSupplier}
              setOpenSupplier={setOpenSupplier}
              moduleType={moduleType}
            />
          ) : null
        }
      />
      {open ? (
        <RightSupplierMenu
          open={openSupplier}
          onClose={() => setOpenSupplier(false)}
          otherType={supplierId?.materialType}
          type={moduleType}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default RightBacksplashCustomDesign;

const RenderContent = ({ setOpenSupplier, moduleType }) => {
  const {
    // supplierId,
    sceneManager,
    currentMaterial,
    setCurrentMaterial,
    // setSupplierId,
  } = useContext(DesignerPageContext);
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { listMaterials, groupMaterials } = useSelector(
    state => state.materialReducer
  );
  const {
    suppliers,
    currentSupplier: { [moduleType]: supplierId },
  } = useSelector(state => state.supplier);

  const [activeKeys, setActiveKeys] = useState([]);

  const loadGroupMaterial = useCallback(
    ({ material_type: materialType }) => {
      try {
        const data = suppliers.data[materialType];
        let idSupplier = null;

        if (moduleType === ModuleType.BACKSPLASH) {
          const backsplashTexture = sceneManager?.backsplash?.texture;
          idSupplier = backsplashTexture?.supplier;
        } else if (moduleType === ModuleType.COUNTERTOP) {
          const countertopTexture = sceneManager?.countertop?.texture;
          idSupplier = countertopTexture?.supplier;
        }
        const temp = {
          ...supplierId,
          ...{
            id: data?.[0]?.id,
            ...(idSupplier ?? {}),
            materialType: materialType,
          },
        };
        dispatch(setCurrentSupplier({ [moduleType]: temp }));
        if (temp?.id) {
          dispatch(
            fetchGroupMaterial({
              // offset,
              // limit,
              productType: '',
              materialType: materialType,
              supplier: temp?.id,
            })
          );
        }
      } catch {
        openMessageError({ content: t('Failed to load data!') });
      }
    },
    [supplierId, sceneManager, suppliers]
  );

  useEffect(() => {
    if (sceneManager && open) {
      let material = {};
      if (moduleType === ModuleType.BACKSPLASH) {
        material = {
          ...material,
          [moduleType]: sceneManager.backsplash,
        };
      } else if (moduleType === ModuleType.COUNTERTOP) {
        material = {
          ...material,
          [moduleType]: sceneManager.countertop,
        };
      }

      setCurrentMaterial({ ...material });
      if (material[moduleType]?.texture?.supplier?.group) {
        setActiveKeys(prev => [
          ...prev,
          material[moduleType].texture.supplier.group,
        ]);
        dispatch(
          fetchMaterialsByGroup({
            materialGroup: material[moduleType].texture.supplier.group,
          })
        );
      }
    }
  }, [open, moduleType, sceneManager]);

  useEffect(() => {
    if (currentMaterial?.[moduleType]?.material) {
      loadGroupMaterial({
        material_type: currentMaterial?.[moduleType]?.material?.type,
      });
    }
  }, [currentMaterial]);

  useEffect(() => {
    if (supplierId && currentMaterial?.[moduleType]) {
      dispatch(
        fetchGroupMaterial({
          productType: '',
          materialType: currentMaterial?.[moduleType]?.material?.type,
          supplier: supplierId?.id,
        })
      );
    }
  }, [supplierId]);

  useEffect(() => {
    const otherType = supplierId?.materialType;
    if (!suppliers.data[otherType]?.length && otherType) {
      dispatch(fetchSuppliers({ textureType: otherType }));
    }
  }, [supplierId, currentMaterial]);

  return (
    <>
      {suppliers.data[supplierId?.materialType]?.find(
        item => supplierId && item.id === supplierId?.id
      ) ? (
        <div
          key={1}
          className="flex p-16 flex-col items-start gap-8 self-stretch bg-fills-white"
        >
          {[...(suppliers.data[supplierId?.materialType] ?? [])]
            ?.filter(item => supplierId && item.id === supplierId?.id)
            .map((item, index) => {
              return (
                <SelectionSupplier
                  key={index}
                  src={item.icon_url}
                  title={item.name}
                  description={''}
                  className={'self-stretch'}
                  onClick={() => setOpenSupplier(true)}
                  actions={
                    <ButtonTertiarySmall
                      title={t('Change')}
                      onClick={e => {
                        // setOpenSupplier(true)
                      }}
                    />
                  }
                />
              );
            })}
        </div>
      ) : null}

      <div
        className="flex flex-col p-8 items-start gap-16 grow self-stretch overflow-auto"
        style={{ backgroundColor: '#F7F7F7' }}
      >
        <div
          id="scrollableDiv"
          className="flex flex-col self-stretch grow overflow-scroll"
        >
          {groupMaterials.data[`${supplierId?.materialType}-${supplierId?.id}`]
            ?.length ? (
            <Collapse
              expandIcon={({ isActive, panelKey }) =>
                panelKey === listMaterials.isLoading ? (
                  <Spin spinning size="small" />
                ) : (
                  <span className="w-16 h-16 flex">
                    {isActive ? <Icon.ICExpandLess /> : <Icon.ICExpandMore />}
                  </span>
                )
              }
              activeKey={activeKeys}
              onChange={() => {}}
              className="self-stretch overflow-auto grow"
              rootClassName="self-stretch grow"
              items={
                [
                  ...(
                    groupMaterials.data[
                      `${supplierId?.materialType}-${supplierId?.id}`
                    ] ?? []
                  ).map(item => {
                    const groupId = item.id;
                    const isEmpty = !listMaterials.data[groupId]?.length;
                    const isLoading =
                      isEmpty && listMaterials.isLoading === groupId;
                    const formularPrice = item.description?.includes('giagoc')
                      ? item.description
                      : undefined;
                    return {
                      key: groupId,
                      onItemClick: e => {
                        if (!listMaterials.data[groupId]) {
                          setActiveKeys(prev => [...prev, e]);
                          dispatch(
                            fetchMaterialsByGroup({
                              materialGroup: e,
                            })
                          );
                        } else {
                          setActiveKeys(prev => {
                            if (prev.includes(e)) {
                              return prev.filter(key => key !== e);
                            } else {
                              return [...prev, e];
                            }
                          });
                        }
                      },
                      label: (
                        <span className="text-title-small">
                          {getValueFromString(item.name)}
                        </span>
                      ),
                      classNames: {
                        body: 'self-stretch grow !p-0',
                        header: 'self-stretch grow',
                      },
                      isActive: !isLoading,
                      onKeyDown: e => {
                        e.stopPropagation();
                      },
                      children: (
                        <div
                          className="flex flex-row flex-wrap gap-2"
                          style={{ background: 'rgb(247, 247, 247)' }}
                        >
                          {isEmpty && !isLoading ? (
                            <div className="flex self-stretch items-center justify-center grow">
                              <Empty />
                            </div>
                          ) : (
                            <></>
                          )}
                          {listMaterials.data[groupId]?.map((item, index) => {
                            return (
                              <CardMaterial
                                key={index}
                                hideOption={true}
                                item={{
                                  src: item.thumbnail_url,
                                  title: item.name,
                                  description: item.code,
                                }}
                                active={
                                  item.id ===
                                  currentMaterial?.[moduleType]?.texture
                                    ?.textureId
                                }
                                onClick={async func => {
                                  if (item.thumbnail_url) {
                                    const textureController =
                                      sceneManager.textureController;
                                    const scene = sceneManager?.scene;
                                    const texture = {
                                      textureId: item.id,
                                      textureCode:
                                        item.name + ' - (' + item.code + ')',
                                      formularPrice,
                                      texturePrice: item.price,
                                      url: item.thumbnail_url,
                                      supplier: {
                                        ...(supplierId ?? {}),
                                        id: item.supplier,
                                        group: groupId,
                                      },
                                    };
                                    await textureController.changeTextureCountertopAndBacksplash(
                                      {
                                        scene,
                                        textureType: 'map',
                                        texture,
                                        excludeMeshes: [],
                                        includeMeshes:
                                          moduleType === ModuleType.COUNTERTOP
                                            ? ['MAT-DA', 'COUNTERTOP']
                                            : ['BACKSPLASH', 'VACH-BEP'],
                                        includeTypes:
                                          moduleType === ModuleType.COUNTERTOP
                                            ? [ModuleType.COUNTERTOP]
                                            : [ModuleType.BACKSPLASH],
                                      }
                                    );

                                    let material = {};
                                    if (moduleType === ModuleType.COUNTERTOP) {
                                      const newValue = {
                                        ...(sceneManager.countertop ?? {}),
                                        supplier: {
                                          ...(supplierId ?? {}),
                                          id: item.supplier,
                                          group: groupId,
                                        },
                                        using: true,
                                        texture,
                                      };
                                      sceneManager.countertop = {
                                        ...newValue,
                                      };
                                      material = {
                                        ...material,
                                        [moduleType]: {
                                          ...newValue,
                                        },
                                      };
                                    } else {
                                      const newValue = {
                                        ...(sceneManager.backsplash ?? {}),
                                        supplier: {
                                          ...(supplierId ?? {}),
                                          id: item.supplier,
                                          group: groupId,
                                        },
                                        using: true,
                                        texture,
                                      };
                                      sceneManager.backsplash = {
                                        ...newValue,
                                      };
                                      material = {
                                        ...material,
                                        [moduleType]: {
                                          ...newValue,
                                        },
                                      };
                                    }
                                    setCurrentMaterial({ ...material });
                                    await sceneManager.calculateTotalCost?.({});
                                    func();
                                  } else {
                                    openMessageError({
                                      content: t(
                                        'The texture has no data, please select another texture.'
                                      ),
                                    });
                                  }
                                }}
                              />
                            );
                          })}
                        </div>
                      ),
                    };
                  }),
                ] //   formLayout.map((panel) => ({
                //   ...panel,
                //   extra: <ButtonIconGhostSmall icon={<Icon.ICSelectAll />} />,
                // }))
              }
            />
          ) : (
            <Empty />
          )}
        </div>
      </div>
    </>
  );
};
